import { ensureAppInfoReady } from './appInfo'
import { buildAnalyticsEvent } from './buildEvent'
import { isAnalyticsEnabled } from './config'
import { enqueueAnalyticsEvent } from './queue'
import type { AnalyticsTrackInput } from './types'

export function track(eventName: string, props?: Record<string, unknown>): void {
  if (!isAnalyticsEnabled()) return

  const input: AnalyticsTrackInput = {
    event_name: eventName,
    ...(props ?? {})
  }

  const run = () => {
    const event = buildAnalyticsEvent(input)
    if (!event) return
    enqueueAnalyticsEvent(event)
  }

  void ensureAppInfoReady().then(run).catch(run)
}
